/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IssueCsrfToken400Response
 */
export interface IssueCsrfToken400Response {
    /**
     * ステータス
     * @type {number}
     * @memberof IssueCsrfToken400Response
     */
    status: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof IssueCsrfToken400Response
     */
    message: string;
}

/**
 * Check if a given object implements the IssueCsrfToken400Response interface.
 */
export function instanceOfIssueCsrfToken400Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function IssueCsrfToken400ResponseFromJSON(json: any): IssueCsrfToken400Response {
    return IssueCsrfToken400ResponseFromJSONTyped(json, false);
}

export function IssueCsrfToken400ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IssueCsrfToken400Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
    };
}

export function IssueCsrfToken400ResponseToJSON(value?: IssueCsrfToken400Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
    };
}

